// extracted by mini-css-extract-plugin
export default {"_":"circularLoader____k1yQk","loader-1":"circularLoader_loader-1__oxF8s","loader-2":"circularLoader_loader-2__rqOwm","loader-3":"circularLoader_loader-3__40oVy"};